// extracted by mini-css-extract-plugin
export default {"hidden":"UniversalHiddenScreen_hidden__ifU6S","hidden__background":"UniversalHiddenScreen_hidden__background__nfdbd"};